import { useDispatch } from "react-redux";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const GOOGLE_CLIENT_ID =
  "907338919971-nrhdck4hkb5lhm6u5s7mtncgucbppkqr.apps.googleusercontent.com";
const GOOGLE_CLIENT_SECRET = "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";
const url = window.location.origin;
const REDIRECT_URI = `${url}/oauth2/callback`;

function getQueryParam(search, param) {
  const params = new URLSearchParams(search);
  return params.get(param);
}

const GoogleOAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  useEffect(() => {
    const code = getQueryParam(location.search, "code");
    if (!code) {
      navigate("/");
      return;
    }

    // Exchange code for id_token
    fetch("https://oauth2.googleapis.com/token", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        code,
        client_id: GOOGLE_CLIENT_ID,
        client_secret: GOOGLE_CLIENT_SECRET,
        redirect_uri: REDIRECT_URI,
        grant_type: "authorization_code",
      }),
    })
      .then((res) => res.json())
      .then(async (data) => {
        if (data.id_token) {
          const success = await login(data.id_token);
          if (success) {
            navigate("/home");
          } else {
            setError("Google login failed. Invalid or expired token.");
            navigate("/");
          }
        } else {
          setError("Google login failed. No id_token returned.");
          navigate("/");
        }
      })
      .catch(() => {
        setError("Google login failed. Network or server error.");
        navigate("/");
      });
  }, [location, login, navigate, dispatch]);

  return <div>{error ? error : "Logging in with Google..."}</div>;
};

export default GoogleOAuthCallback;
